import React from 'react';
import PropTypes from 'prop-types';
import { useResetAtom } from 'jotai/utils';
import { useNavigate } from 'react-router-dom';
import { isEmbedded, Atoms, SupportUtils, t as commonT } from '@cyberint/common-utils';
import { Button } from '../Buttons/Button';
import { Images } from '../Images';
import * as S from './invalid-route-styled';

export const InvalidRouteType = {
  Unauthorized: 'unauthorized',
  NotFound: 'not_found'
};

const InvalidRouteData = {
  [InvalidRouteType.Unauthorized]: {
    icon: <S.StyledImage src={Images.Unauthorized} alt="Image with a lock" />,
    title: commonT('common.unAuth'),
    message: commonT('common.unAuthPage'),
    button: commonT('common.homePage')
  },
  [InvalidRouteType.NotFound]: {
    icon: <Images.NoDataFoundDark height={100} />,
    title: commonT('common.notFound'),
    button: commonT('common.homePage')
  }
};

const InvalidRoute = ({ title, type, message, button, onButtonClick }) => {
  const navigate = useNavigate();
  const resetFirstPath = useResetAtom(Atoms.firstPathState);

  const onClick = e => {
    if (onButtonClick) {
      onButtonClick?.(e);
      return;
    }
    if (isEmbedded) {
      resetFirstPath();
    }
    navigate('/');
  };

  const onContactSupportClickHandler = () => {
    window.open(SupportUtils.SUPPORT_URL, '_blank', 'noopener,noreferrer');
  };

  const data = InvalidRouteData[type];
  const titleLabel = title ?? data?.title;
  const messageLabel = message ?? data?.message;
  const buttonLabel = button ?? data?.button;

  return (
    <S.Container>
      <S.StyledErrorContainer>
        {data?.icon}
        {titleLabel && <S.StyledTitle>{titleLabel}</S.StyledTitle>}
        {messageLabel && <S.StyledMessage>{messageLabel}</S.StyledMessage>}
        {buttonLabel && (
          <S.StyledWrapper>
            <Button onClick={onClick}>{buttonLabel}</Button>
          </S.StyledWrapper>
        )}
        <S.StyledWrapper>
          <Button.Linked onClick={onContactSupportClickHandler}>{commonT('common.contactSupport')}</Button.Linked>
        </S.StyledWrapper>
      </S.StyledErrorContainer>
    </S.Container>
  );
};

InvalidRoute.propTypes = {
  title: PropTypes.node,
  message: PropTypes.node,
  button: PropTypes.string,
  onButtonClick: PropTypes.func,
  type: PropTypes.string
};

export default InvalidRoute;
